import { useContext, useMemo } from 'react';
import { VirtualSlotsPlaceholderContext } from '../slotsPlaceholderContext';
export const useWidgetPlugin = (slotId) => {
    var _a;
    const slots = useContext(VirtualSlotsPlaceholderContext);
    const widgetPlugin = (_a = slots === null || slots === void 0 ? void 0 : slots[slotId]) !== null && _a !== void 0 ? _a : null;
    const PluginComponent = useMemo(() => () => widgetPlugin, [widgetPlugin]);
    return {
        PluginComponent,
        isEmpty: !widgetPlugin,
    };
};
//# sourceMappingURL=useWidgetPlugin.js.map